var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"space-y-2 w-full"},[_c('UploadDocument',{attrs:{"multiple":true},on:{"droppedFiles":_vm.droppedDocuments,"dropped":_vm.droppedDocument}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }